import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("adgen_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function setToken(t) {
  if (t) localStorage.setItem("adgen_token", t);
}
export function clearToken() {
  localStorage.removeItem("adgen_token");
}

// Build a displayable src for generated media. External URLs pass through unchanged;
// our own /api/media|files URLs get the backend base + auth token appended.
export function mediaUrl(u) {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  const t = localStorage.getItem("adgen_token");
  const sep = u.includes("?") ? "&" : "?";
  return `${BASE}${u}${t ? `${sep}t=${t}` : ""}`;
}

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

// Fetch a media URL as a blob and trigger a file download in the browser.
export async function downloadMedia(u, filename) {
  const token = localStorage.getItem("adgen_token");
  // External URLs (rare fallback) — just open in a new tab, browsers block cross-origin blob fetches.
  if (u.startsWith("http")) {
    window.open(u, "_blank");
    return;
  }
  const res = await axios.get(`${BASE}${u}`, {
    responseType: "blob",
    params: { t: token, download: 1 },
  });
  const blob = res.data;
  const mime = blob.type || res.headers?.["content-type"] || "image/png";
  const ext = mime.includes("jpeg") ? "jpg" : (mime.split("/")[1] || "png").split(";")[0];
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename || `adgen-${Date.now()}`}.${ext}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

export default client;
